import { render, staticRenderFns } from "./simKefu.vue?vue&type=template&id=3aae44a3&scoped=true&"
import script from "./simKefu.vue?vue&type=script&lang=js&"
export * from "./simKefu.vue?vue&type=script&lang=js&"
import style0 from "./simKefu.vue?vue&type=style&index=0&id=3aae44a3&lang=less&scoped=true&"
import style1 from "./simKefu.vue?vue&type=style&index=1&id=3aae44a3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aae44a3",
  null
  
)

export default component.exports